const ChatIcon = ({ size = 24, color = "black" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.98925 21.7902C4.1853 22.2848 4.22895 22.8267 4.11458 23.3462L2.69458 27.7329C2.64883 27.9554 2.66066 28.1858 2.72895 28.4024C2.79724 28.619 2.91973 28.8146 3.0848 28.9706C3.24988 29.1266 3.45206 29.2378 3.67218 29.2938C3.8923 29.3497 4.12306 29.3485 4.34258 29.2902L8.89325 27.9596C9.38353 27.8623 9.89129 27.9048 10.3586 28.0822C13.2058 29.4119 16.4311 29.6932 19.4654 28.8765C22.4998 28.0599 25.1483 26.1978 26.9435 23.6187C28.7388 21.0397 29.5654 17.9094 29.2776 14.7803C28.9899 11.6511 27.6062 8.72419 25.3707 6.51582C23.1352 4.30746 20.1915 2.95961 17.0591 2.71009C13.9267 2.46057 10.8068 3.3254 8.24984 5.15201C5.69291 6.97862 3.86329 9.64962 3.08377 12.6937C2.30425 15.7379 2.62494 18.9595 3.98925 21.7902Z"
        stroke={color}
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChatIcon;
